import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useMemo } from "react";
import { Button, Form } from "react-bootstrap";
import moment from "moment";
import { useFormik } from "formik";
import { DateRangePicker } from "rsuite";
import { BiSearch,BiReset } from "react-icons/bi";
import { Stack } from 'rsuite';
import startOfMonth from 'date-fns/startOfMonth';
import Sidebar from "../../includes/Sidebar";
import { downloadXl, predefinedBottomRanges } from "../../../functions";
import { Tooltip } from "@mui/material";
import { seErrorMessage } from "../../../slice/error/errorSlice";
import { useDispatch } from "react-redux";
import Select, { components } from "react-select";
import { format } from "date-fns";
import { HiChevronDown } from "react-icons/hi";
import { TbGridDots } from "react-icons/tb";
import { EdiMonitorService } from "../../../services/EdiMonitorService";
import { InvoiceReportService } from "../../../services/InvoiceReportService";
import { BsCloudDownloadFill } from "react-icons/bs";


const datatableCustomStyles = {
  rows: {
    style: {
      minHeight: '20px',
      fontSize: '0.7em',
      fontColor: '#212529 !important',
      width: '100%'
    },
  },
  headCells: {
    style: {
      paddingLeft: '5px',
      paddingRight: '5px',
      textTransform: "uppercase",
      fontSize: '0.7em',
      fontWeight: '800',
      fontColor: '#6c757d !important',
      opacity: 1,
      minHeight: "10px",
    },
  },
  cells: {
    style: {
      paddingLeft: '8px',
      paddingRight: '8px',
      width: "100%",
    },
  },
  pagination: {
    style: {
      color: '#000',
      fontSize: '13px',
      minHeight: '56px',
      backgroundColor: '#fff',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      borderTopColor: '#f2f2f2',
    },
    pageButtonsStyle: {
      borderRadius: '50%',
      height: '40px',
      width: '40px',
      padding: '8px',
      margin: '0px',
      cursor: 'pointer',
      transition: '0.4s',
      color: '#000',
      fill: '#000',
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: '#e2e2e2',
        fill: '#e2e2e2',
      },
      '&:hover:not(:disabled)': {
        backgroundColor: '#f2f2f2',
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: '#f5f5f5',
      },
    },
  },
};

function LoadReport837() {
  const dispatch = useDispatch();

  const [reRenderDataTable, setRerenderDataTable] = useState(false);
  const [pageno, setPageNo] = useState(1);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(100);
  const [colorRow, setColorRow] = React.useState({});
  const [data, setData] = useState({});
  const [limit, setLimit] = useState(100);
  const [clients, setClients] = useState([]);
  const [isFocusedClient, setIsFocusedClient] = useState(false);

  const [searchedData, setSearchedData] = useState({
    file_name: "",
    zip_file_name: "",
    client: "",
    file_type: "",
    arrival_time: [
      startOfMonth(new Date(new Date().setHours(0, 0, 0, 0))),
      new Date(new Date().setHours(23, 59, 59, 999))
    ],
    created_date: "",
    partners: "",
  });

  const [partners, setPartners] = useState([]);
  const [isFocusedPartner, setIsFocusedPartner] = useState(false);

  const [isInitSearch, setIsInitSearch] = useState(true);

  const ediMonitorService = new EdiMonitorService();
  const invoiceReportService = new InvoiceReportService();
  const { getEdiFilesMonitor, exportEdiFilesReport } = ediMonitorService;
  const { getClientPartnerDropdown, getPartnerDropdown } = invoiceReportService;

  const DropdownIndicator = ({ state, ...props }) => {
    return (
      <components.DropdownIndicator {...props}>
        {filterState && filterState[state] && filterState[state].length > 1 ? <TbGridDots style={{ fontSize: "1.5em" }} /> : <HiChevronDown style={{ fontSize: "1.5em" }} />}
      </components.DropdownIndicator>
    );
  };

  const [filterState, setFilterState] = useState({
    client: "",
    file_type: "",
    partners: ""
  });

  const handleOnMultySelectChange = async (selected, name) => {
    let selectedIds = [];

    if (selected && Array.isArray(selected)) {
      selected.forEach((option) => {
        selectedIds.push(option.value);
      });
    }

    searchFormik.setValues({ ...searchFormik.values, [name]: selectedIds });
    setFilterState({
      ...filterState,
      [name]: selected || [],
    });
  };
  const handlechangePartner = (e) => {
    const partnersIds = e?.map((i) => i?.value);
    searchFormik.setFieldValue("partners", partnersIds);
    getClientPartnerDropdown(partnersIds?.length > 0 ? partnersIds : partners.map((i) => i?.value)).then((response) => {
      if (response?.status) {
        const data = response?.data?.partners;
        const clientIdArr = [];
        setClients(
          data?.map((result) => {
            result?.clients?.map((item) => clientIdArr.push(item.value));
            return { options: result?.clients, label: result?.partner, id: result?.pk };
          })
        );
      }
    });
  };

  const handleOnSingleSelectChange = (selected, name) => {
    searchFormik.setValues({ ...searchFormik.values, [name]: selected ? selected.value : "" });
    setFilterState({
      ...filterState,
      [name]: selected,
    });
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLimit(newPerPage);
    setPageNo(1);
    fetchData(1, newPerPage, searchedData?.file_name, searchedData?.zip_file_name, searchedData?.client, searchedData?.file_type, searchedData?.arrival_time, searchedData?.created_date, searchedData?.partners);
    handleResetDataTable();
  };

  const handlePageChange = page => {
    setPageNo(page);
    fetchData(page, limit, searchedData?.file_name, searchedData?.zip_file_name, searchedData?.client, searchedData?.file_type, searchedData?.arrival_time, searchedData?.created_date, searchedData?.partners);
  };

  function formatDateRange(dateRange) {
    if (!Array.isArray(dateRange) || dateRange.length !== 2) {
      return '';
    }

    const [start, end] = dateRange.map((d) => new Date(d));

    const formattedStart = format(start, 'MM/dd/yyyy') + ' 00:00:00';
    const formattedEnd = format(end, 'MM/dd/yyyy') + ' 23:59:59';

    return `${formattedStart} - ${formattedEnd}`;
  }

  const fetchData = (page, limit, file_name, zip_file_name, client, file_type, arrival_time_full, created_date_full, partners) => {
    setLoading(true);

    const arrival_time = formatDateRange(arrival_time_full);
    const created_date = formatDateRange(created_date_full);

    getEdiFilesMonitor(page, limit, file_name, zip_file_name, client, file_type, arrival_time, created_date, partners).then((response) => {


      
      setData(response?.data);
      setLimit(limit);
      setPageNo(page);
      setTotalRows(response?.data?.count);
      setLoading(false);
      if (response?.errors?.arrival_time) {
        dispatch(seErrorMessage({ message: response?.errors?.arrival_time[0], is_show: true }));
      }
      if (response?.errors?.created_date) {
        dispatch(seErrorMessage({ message: response?.errors?.created_date[0], is_show: true }));
      }
    });
  };

  useEffect(() => {
    getClientPartnerDropdown().then((response) => {
      const data = response?.data?.partners;
      if (Array.isArray(data)) {
        setClients(
          data.map((result) => ({
            options: result?.clients || [],
            label: result?.partner || "N/A",
            id: result?.pk,
          }))
        );
      } else {
        setClients([]);
      }
    });
    getPartnerDropdown().then((response) => {
      setPartners(Array.isArray(response?.data) ? response?.data : []);
    });
  }, []);

  const searchFormik = useFormik({
    initialValues: {
      file_name: "",
      zip_file_name: "",
      arrival_time: [startOfMonth(new Date().setHours(0, 0, 0, 0)), new Date().setHours(23, 59, 59, 59)],
      client: [],
      file_type: "",
      created_date: "",
      partners: [],
    },
    validate: (value) => {
      const errors = {};
      // Require at least one filter: either created_date OR any other filter
      const hasCreatedDate = value?.created_date?.length > 0;
      const hasArrivalTime = value?.arrival_time?.length > 0;
      const hasFileName = value?.file_name?.trim() !== "";
      const hasZipFileName = value?.zip_file_name?.trim() !== "";
     
      
      const hasAnyFilter = hasCreatedDate || hasArrivalTime || hasFileName || hasZipFileName;
      
      if (!hasAnyFilter) {
        errors.created_date = "At least one filter is required";
      }
      return errors;
    },
    onSubmit: (values) => {
      setIsInitSearch(false);
      searchData(values);
      setSearchedData(values);
      handleResetDataTable();
    }
  });

  const handleRowClick = (row) => {
    setColorRow(row);
  };

  const columns = useMemo(
    () => [
      {
        id: 'S.NO',
        name: 'S.NO',
        selector: (row, index) =>
          Number(pageno) > 1
            ? (Number(pageno) - 1) * Number(limit) + index + 1
            : index + 1,
        cell: (row, index) =>
          <div style={{ width: "50px" }} onClick={() => handleRowClick(row)}>
            {Number(pageno) > 1
              ? (Number(pageno) - 1) * Number(limit) + index + 1
              : index + 1}
          </div>,
        wrap: true,
        width: "50px",
      },
      {
        id: 'client_name',
        name: 'CLIENT NAME',
        width: "10%",
        selector: row => row?.client_name,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)} className="text-truncate">
            {row?.client_name}
          </span>,
        left: true,
        wrap: true,
        reorder: false,
        width: "150px",
      },
      {
        id: 'client_code',
        name: 'CLIENT CODE',
        width: "120px",
        selector: row => row?.client_code,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)} className="text-truncate">
            {row?.client_code}
          </span>,
        left: true,
        wrap: true,
        width: "150px",
      },
      {
        id: 'zip_file_name',
        name: 'LBX FILE NAME',
        width: "120px",
        selector: row => row?.zip_file_name,
        cell: (row) =>
          <Tooltip title={row?.zip_file_name || ''} placement="top" arrow>
            <span style={{ width: "150px" }} onClick={() => handleRowClick(row)} className="text-truncate">
              {row?.zip_file_name}
            </span>
          </Tooltip>,
        left: true,
        wrap: true,
        width: "150px",
      },
      {
        id: 'file_name',
        name: 'FILE NAME',
        width: "150px",
        selector: row => row?.file_name,
        cell: (row) =>
          <Tooltip title={row?.file_name || ''} placement="top" arrow>
            <span style={{ width: "150px" }} onClick={() => handleRowClick(row)} className="text-truncate">
              {row?.file_name}
            </span>
          </Tooltip>,
        left: true,
        wrap: true,
        width: "150px",
      },
      {
        id: 'arrival_time',
        name: 'ARRIVAL TIME',
        width: "150px",
        selector: row => row?.arrival_time,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)}>
            {row?.arrival_time}
          </span>,
        left: true,
        wrap: true,
      },
      {
        id: 'file_type',
        name: 'FILE TYPE',
        width: "150px",
        selector: row => row?.file_type,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)}>
            {row?.file_type}
          </span>,
        left: true,
        wrap: true,
      },
      {
        id: 'file_size',
        name: 'FILE SIZE',
        width: "150px",
        selector: row => row?.file_size,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)}>
            {row?.file_size}
          </span>,
        left: true,
        wrap: true,
      },
      {
        id: 'status',
        name: 'STATUS',
        width: "150px",
        selector: row => row?.status,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)} className="text-truncate">
            {row?.status}
          </span>,
        left: true,
        wrap: true,
      },
      {
        id: 'load_started_at',
        name: 'LOAD STARTED AT',
        width: "150px",
        selector: row => row?.load_started_at,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)}>
            {row?.load_started_at}
          </span>,
        left: true,
        wrap: true,
      },
      {
        id: 'load_completed_at',
        name: 'LOAD COMPLETED AT',
        width: "150px",
        selector: row => row?.load_completed_at,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)}>
            {row?.load_completed_at}
          </span>,
        left: true,
        wrap: true,
      },
      {
        id: 'bill_print_date',
        name: 'BILL PRINT DATE',
        width: "150px",
        selector: row => row?.bill_print_date,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)}>
            {row?.bill_print_date}
          </span>,
        left: true,
        wrap: true,
      },
      {
        id: 'interchange_date',
        name: 'INTERCHANGE DATE',
        width: "150px",
        selector: row => row?.interchange_date,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)}>
            {row?.interchange_date}
          </span>,
        left: true,
        wrap: true,
      },
      {
        id: 'claims_count',
        name: 'CLAIMS COUNT',
        width: "150px",
        selector: row => row?.claims_count,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)}>
            {row?.claims_count}
          </span>,
        left: true,
        wrap: true,
      },
      {
        id: 'service_line_count',
        name: 'SERVICE LINE COUNT',
        width: "150px",
        selector: row => row?.service_line_count,
        cell: (row) =>
          <span style={{ width: "150px" }} onClick={() => handleRowClick(row)}>
            {row?.service_line_count}
          </span>,
        left: true,
        wrap: true,
      },
    ],
    [limit, pageno],
  );

  const conditionalRowStyles = [
    {
      when: row => colorRow.pk == row.pk ? true : false,
      style: (row, index) => ({
        backgroundColor: colorRow?.pk == row.pk ? '#dbf4f5' : '#f2f2f2',
        color: 'black',
      }),
    },
  ];

  const handleOnDateTimeChange = ({ name, value }) => {
    searchFormik.setValues({ ...searchFormik.values, [name]: value ?? "" });
  };

  const searchData = ({ file_name, zip_file_name, arrival_time, client, file_type, created_date, partners }) => {
    fetchData(1, limit, file_name, zip_file_name, client, file_type, arrival_time, created_date, partners);
  };

  const handleExport = async () => {

    if (!searchFormik?.values?.arrival_time?.length > 0 && !searchFormik?.values?.created_date?.length > 0 && !searchFormik?.values?.file_name && !searchFormik?.values?.zip_file_name) {
      dispatch(seErrorMessage({ message: 'Please select at least one filter before exporting.', is_show: true }));
      return;
    }

    const arrival_time = formatDateRange(searchFormik?.values?.arrival_time);
    const created_date = formatDateRange(searchFormik?.values?.created_date);
    
    setExportLoading(true);
    try {
      const blob = await exportEdiFilesReport(
        searchFormik?.values?.file_name || '',
        searchFormik?.values?.zip_file_name || '',
        searchFormik?.values?.client?.join(',') || '',
        searchFormik?.values?.file_type || '',
        arrival_time,
        created_date,
        searchFormik?.values?.partners?.join(',') || ''
      );
      // Create download link
     downloadXl(blob?.data)
    } catch (error) {
      dispatch(seErrorMessage({ message: 'Failed to export report', is_show: true }));
    } finally {
      setExportLoading(false);
    }
  };

  const handleResetDataTable = () => {
    setRerenderDataTable(true);
  };

  const [fileTypes, _] = useState([
    { value: "1", label: "837" },
    { value: "2", label: "Self Pay" },
  ]);
    const handleResetCallFetch = async () => {
            const currentUrl = window.location.pathname; // Get the current URL
            const decodedUrl = decodeURI(currentUrl); // Decode the URL
            const newUrl = encodeURI(decodedUrl.replace(/\%20/g, "")); // Remove all occurrences of '%20' and encode the new URL
            // const currentUrl2 = SINGLE_LOCKBOX_LOCKBOX_FILES + file_id; // Get the current URL
            // const decodedUrl2 = decodeURI(currentUrl); // Decode the URL
            const newUrl2 = encodeURI(decodedUrl.replace(/\%20/g, "")); // Remove all occurrences of '%20' and encode the new URL

            if (newUrl == newUrl2) {
                    // navigate(QMS)
                    window.location.reload();
            } else {
                    window.location.reload();
            }
    };
  return (
    <React.Fragment>
      <Sidebar />
      <main id="main" className="main">

        <div className="pagetitle tab-fixed-header">
          <h1 id='page-title'>837 Load Report</h1>
        </div>

        <section className="section mt-5 ">
          <div className="row align-items-top py-2 gap-2 gap-md-5">
            <div className="col-lg-12">
              <div className="card mb-5 mb-xl-8 mt-3">

                <Form onReset={handleResetCallFetch} onSubmit={searchFormik.handleSubmit} >
                  <div className=" ">
                    <div className="px-1 py-1 d-flex pe-2 flex-row  gap-2 align-items-center flex-wrap">

                      <Tooltip disableInteractive title={"Arrival Time"} placement="top" arrow>
                        <div className={`${searchFormik.errors.arrival_time ? "date-range-pickr-error " : ""}  correspondenceDatePicker"`}>
                          <Stack direction="column" spacing={8} alignItems="flex-start">
                            <DateRangePicker
                              ranges={predefinedBottomRanges}
                              cleanable={true}
                              placement="auto"
                              appearance="default" format={"MM/dd/yyyy HH:mm:ss"}
                              className="form-date-control form-control-solid b-r-1 text-dark"
                              placeholder={"MM/DD/YYYY HH:MM:SS - MM/DD/YYYY HH:MM:SS"}
                              name="arrival_time"
                              defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                              onChange={(e) => { handleOnDateTimeChange({ name: 'arrival_time', value: e }) }}
                              value={searchFormik?.values?.arrival_time} />
                          </Stack>
                        </div>
                      </Tooltip>

                      <Tooltip disableInteractive title={"Created Date"} placement="top" arrow>
                        <div className={`${searchFormik.errors.created_date ? "date-range-pickr-error " : ""}  correspondenceDatePicker"`}>
                          <Stack direction="column" spacing={8} alignItems="flex-start">
                            <DateRangePicker
                              ranges={predefinedBottomRanges}
                              cleanable={true}
                              placement="auto"
                              appearance="default" format={"MM/dd/yyyy HH:mm:ss"}
                              defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                              className="form-date-control form-control-solid b-r-1 text-dark"
                              placeholder={"MM/DD/YYYY HH:MM:SS - MM/DD/YYYY HH:MM:SS"}
                              name="created_date"
                              onChange={(e) => { handleOnDateTimeChange({ name: 'created_date', value: e }) }}
                              // value={searchFormik?.values?.created_date}
                               />
                          </Stack>
                        </div>
                      </Tooltip>

                      <div className="-tat">
                        <Form.Control
                          type="search"
                          placeholder="File Name"
                          name="file_name"
                          className="form-control form-control-solid"
                          onChange={searchFormik.handleChange}
                          value={searchFormik.values.file_name}
                        />
                      </div>

                      <div className="-tat">
                        <Form.Control
                          type="search"
                          placeholder="LBX File Name"
                          name="zip_file_name"
                          className="form-control form-control-solid"
                          onChange={searchFormik.handleChange}
                          value={searchFormik.values.zip_file_name}
                        />
                      </div>

                        <div>
                        <Select
                          options={partners}
                          className=""
                          classNamePrefix="select"
                          placeholder="Partner"
                          menuPlacement="auto"
                          maxMenuHeight={300}
                          isClearable
                          isMulti
                          name="partners"
                          tabSelectsValue={false}
                          onChange={(val) => {
                            handlechangePartner(val, "partner");
                          }}
                          onBlur={() => setIsFocusedPartner(false)}
                          value={partners.filter((item) => searchFormik.values.partners?.includes(item.value))}
                          hideSelectedOptions={false}
                          styles={{
                            container: (styles, state) => ({
                              ...styles,
                              borderRadius: "9px",
                            }),
                            control: (styles, state) => ({
                              ...styles,
                              backgroundColor: "hsl(204deg 33.33% 97.06%)",
                              borderStyle: "none", boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: "30px",
                            }),
                            indicatorSeparator: styles => ({
                              ...styles, width: "0px",
                              minHeight: "20px",
                              maxHeight: "30px",
                            }),

                            valueContainer: (styles, state) => ({
                              ...styles,
                              maxHeight: "30px",
                              overflow: 'scroll',
                            }),
                            option: (styles, state) => ({
                              ...styles,
                              backgroundColor: state.isSelected ? '#d9f4f5' : 'inherit',
                              color: state.isSelected ? '#000000' : 'inherit',
                              '&:hover': { backgroundColor: state.isSelected ? '#d9f4f5' : 'rgb(222, 235, 255)' }

                            })
                          }}
                          menuPortalTarget={document.body}
                          closeMenuOnSelect={false} // Keep the menu open after selecting an option

                        />
                      </div>

                      <div className="-tat">
                        <Select
                          isMulti
                          options={clients || []}
                          className="select-search"
                          components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="client" /> }}
                          classNamePrefix="select"
                          placeholder="Client"
                          isClearable
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          name="client"
                          onFocus={() => setIsFocusedClient(true)}
                          onBlur={() => setIsFocusedClient(false)}
                          onChange={(e) => handleOnMultySelectChange(e, "client")}
                          defaultValue={searchFormik?.values?.client}
                          value={clients.flatMap(i => i?.options).filter(i => searchFormik?.values?.client?.includes(i.value))}
                          styles={{
                            container: (styles, state) => ({
                              ...styles,
                              borderRadius: "9px",
                            }),
                            control: (styles, state) => ({
                              ...styles,
                              backgroundColor: "hsl(204deg 33.33% 97.06%)",
                              borderStyle: "none",
                              boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: "30px",
                            }),
                            indicatorSeparator: (styles) => ({
                              ...styles,
                              width: "0px",
                              minHeight: "20px",
                              maxHeight: "30px",
                            }),
                            valueContainer: (styles, state) => ({
                              ...styles,
                              maxHeight: "30px",
                              overflow: "scroll",
                            }),
                            option: (styles, state) => ({
                              ...styles,
                              backgroundColor: state.isSelected ? "#d9f4f5" : "inherit",
                              color: state.isSelected ? "#000000" : "inherit",
                              "&:hover": { backgroundColor: state.isSelected ? "#d9f4f5" : "rgb(222, 235, 255)" },
                            }),
                          }}
                        />
                      </div>

                      <div className="-tat">
                        <Select
                          options={fileTypes}
                          className="select-search"
                          components={{ DropdownIndicator: (props) => <DropdownIndicator {...props} state="file_type" /> }}
                          classNamePrefix="select"
                          placeholder="File Type"
                          isClearable
                          name="file_type"
                          onChange={(e) => handleOnSingleSelectChange(e, "file_type")}
                          value={fileTypes?.find(option => option.value === searchFormik?.values?.file_type) || null}
                          styles={{
                            container: (styles, state) => ({
                              ...styles,
                              borderRadius: "9px",
                            }),
                            control: (styles, state) => ({
                              ...styles,
                              backgroundColor: "hsl(204deg 33.33% 97.06%)",
                              borderStyle: "none",
                              boxShadow: "none",
                              borderRadius: "10px",
                              maxHeight: "30px",
                            }),
                            indicatorSeparator: (styles) => ({
                              ...styles,
                              width: "0px",
                              minHeight: "20px",
                              maxHeight: "30px",
                            }),
                            valueContainer: (styles, state) => ({
                              ...styles,
                              maxHeight: "30px",
                            }),
                            option: (styles, state) => ({
                              ...styles,
                              backgroundColor: state.isSelected ? "#d9f4f5" : "inherit",
                              color: state.isSelected ? "#000000" : "inherit",
                              "&:hover": { backgroundColor: state.isSelected ? "#d9f4f5" : "rgb(222, 235, 255)" },
                            }),
                          }}
                        />
                      </div>
                    <div>
                            <Tooltip disableInteractive title="Search" placement="top" arrow>
                                    <Button className="btn btn-light btn-active-primary jobMonitor-Buttons " type="submit" disabled={loading}>
                                            <span className="svg-icon svg-icon-3 ">
                                                    {!loading ? (
                                                            <BiSearch className="jobMonitor-svg" />
                                                    ) : (
                                                            <div className="spinner-border spinner-border-sm text-light" role="status"></div>
                                                    )}
                                            </span>
                                    </Button>
                            </Tooltip>
                    </div>
                    <div>
                        <Tooltip disableInteractive title="Reset" placement="top" arrow disabled={loading} >
                                <Button
                                        className="btn btn-light btn-active-primary  jobMonitor-Buttons"
                                        //onClick={handleResetCallFetch}
                                        type="reset"
                                >
                                        <span className="svg-icon svg-icon-3">
                                                <BiReset className="jobMonitor-svg" />
                                        </span>
                                </Button>
                        </Tooltip>
                    </div>
                      <div>
                        <Tooltip disableInteractive title={"Download"} placement="top" arrow>
                          <Button 
                            className="btn btn-light btn-active-primary" 
                            type="button"
                            onClick={handleExport}
                            disabled={ exportLoading}
                          >
                            {exportLoading ? (
                              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            ) : (
                              <span className="svg-icon svg-icon-3">
                                <BsCloudDownloadFill />
                              </span>
                            )}
                          </Button>
                        </Tooltip>
                      </div>

                    </div>
                  </div>

                </Form>

                <div className="card-body p-common">
                  <div className="table-responsive">
                    <div className="dashboardtable">
                      <DataTable
                        className="custom-datatable"
                        paginationDefaultPage={pageno}
                        fixedHeader={true}
                        progressPending={loading}
                        data={data?.results?.data || []}
                        columns={columns}
                        pointerOnHover={true}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={limit}
                        paginationRowsPerPageOptions={[25, 50, 100, 150, 200]}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        conditionalRowStyles={conditionalRowStyles}
                        theme="solarized"
                        customStyles={datatableCustomStyles}
                        striped={true}
                        expandableRows
                        expandOnRowClicked={false}
                        expandableRowsHideExpander
                        noDataComponent={isInitSearch ? <p className="p-4">Apply filters to refine and display the data</p> : <p className="p-4">There are no records to display</p>}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>
    </React.Fragment >
  )
}
export default LoadReport837
